module.exports = __webpack_public_path__ + "static/media/Hoppip_gaussian2.ca68e30f.png";